<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">REPORTS</h5>

                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-info"
                    fdprocessedid="1yahzs"
                    @click="expSetNow"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-5 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        v-model="busId"
                        @keydown.enter.prevent
                        class="form-control search"
                        placeholder="Enter Bus ID "
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div class="col-xxl-2 col-sm-4">
                    <input
                      type="text"
                      v-model="date"
                      ref="datepicker"
                      class="form-control"
                      placeholder="Choose date"
                    />
                  </div>
                  <div class="col-xxl-2 col-sm-4">
                    <button
                      type="submit"
                      class="btn btn-warning"
                      style="width: 150px"
                      @click.prevent="fetchList"
                    >
                      <div
                        v-if="loading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <span v-else>Get Details</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div>
                <div class="table-responsive table-card mb-1 mt-4">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :headers="headers"
                      :tableData="formattedTrip"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatpickr from "flatpickr";
import { getTripDetails } from "@/apis/report";
import { tripHeaders } from "@/constants/headers";

export default {
  name: "BusReport",

  data() {
    return {
      busId: "RB-BUS-4",
      date: null,
      trips: [],
      loading: false,
    };
  },

  methods: {
    expSetNow() {
      const fields = [
        "tripId",
        "tripNumber",
        "routeId",
        "tripStartTime",
        "tripType",
        "totalBookings",
        "revenue",
      ];
      this.$exportCsv(this.formattedTrip, `${this.busId} Trip.csv`, fields);
    },
    async fetchList() {
      this.loading = true;
      const response = await getTripDetails({
        busId: this.busId,
        date: this.date,
      });
      if (response.success) {
        this.trips = response.data.trip_booking_details;
      }
      this.loading = false;
    },
  },

  beforeCreate() {
    this.headers = tripHeaders;
  },

  computed: {
    formattedTrip() {
      return this.trips
        ?.map((trip) => ({
          tripId: trip.trip_id,
          tripNumber: Number(trip.trip_number),
          routeId: trip.route_id,
          tripStartTime: trip.trip_start_time,
          tripType: trip.trip_type,
          totalBookings: trip.total_bookings,
          revenue: trip.total_revenue,
        }))
        .sort((a, b) => a.tripNumber - b.tripNumber);
    },
  },

  mounted() {
    flatpickr(this.$refs.datepicker, {
      dateFormat: "Y-m-d", 
      allowInput: true,
    });
  },
};
</script>
